<template>
  <div>
    <Dialog
      v-for="dialog in dialogs"
      :key="dialog.id"
      :title="dialog.title"
      :text="dialog.text"
      :buttons="dialog.buttons"
      @click="(index) => onClick(dialog.id, dialog.buttons[index])"
      :zIndex="dialog.zIndex"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Fragment } from "vue-fragment";
import Dialog from "./Dialog";
import { close } from "./DialogUtils";

export default {
  components: {
    Fragment,
    Dialog,
  },
  computed: {
    ...mapGetters(["dialogs"]),
  },
  methods: {
    onClick(id, { value }) {
      close(id, value);
    },
  },
};
</script>

<style>
</style>